/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Event_Ad_Insert_Emotion_Tag_LabelInputs */



/**
* | output |
* | --- |
* | "Insert emotion tag" |
*
* @param {Event_Ad_Insert_Emotion_Tag_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_ad_insert_emotion_tag_label = /** @type {((inputs?: Event_Ad_Insert_Emotion_Tag_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Ad_Insert_Emotion_Tag_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Insérer une balise d'émotion")
	if (locale === "de") return /** @type {LocalizedString} */ ("Emotions-Tag einfügen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Inserisci tag emozione")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Вставить тег эмоции")
	if (locale === "es") return /** @type {LocalizedString} */ ("Insertar etiqueta de emoción")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("插入情绪标签")
	if (locale === "ja") return /** @type {LocalizedString} */ ("感情タグを挿入")
	if (locale === "hi") return /** @type {LocalizedString} */ ("भावना टैग डालें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Inserir etiqueta de emoção")
	return /** @type {LocalizedString} */ ("Insert emotion tag")
});